module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebarf"
  }, [_c('p', {
    staticClass: "fm01"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Front cover. At top: Sungjun Jang’s Pzkpfw III ausf J in 1/35 scale built and painted to represent a vehicle of 3.Kompanie, Panzer-Regiment 8. The photographs in the centre depict, from left to right, a Pzkpfw III ausf G of 2.Kompanie, Panzer-Regiment 5 being unloaded in Tripoli in March 1941. A Pzkpfw III ausf J of 5.Kompanie, Panzer-Regiment 8 pictured in mid-1942. A Panzerbefehlswagen III ausf E from the headquarters of I.Abteilung, Panzer-Regiment 8 photographed in late 1941. The illustration at the foot of the page depicts a Pzkpfw III ausf H of 6.Kompanie, Panzer-Regiment 8. The colours used on these tanks are discussed in detail in the Camouflage & Markings and Technical Details and Modifications sections of this book")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-752aeada","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Fm02.vue
// module id = 66
// module chunks = 0